import { render, staticRenderFns } from "./UserDetailsPorichoyNIDData.vue?vue&type=template&id=737eb326&scoped=true&"
import script from "./UserDetailsPorichoyNIDData.vue?vue&type=script&lang=js&"
export * from "./UserDetailsPorichoyNIDData.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsPorichoyNIDData.vue?vue&type=style&index=0&id=737eb326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737eb326",
  null
  
)

export default component.exports